import React from 'react';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faTrash, faEdit} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {handleImageUrl} from "../../helpers";
import {axios} from "../../axios";

const Card = ({data,setLoading,setPost,post,path}) => {
    const {id,thumbnail,created_at} = data
    const displayTitle = data.title_en || data.title || data.title_de || ''
    const deletePost = ()=>{
        setLoading(true)
        // eslint-disable-next-line no-restricted-globals
        let c = confirm('Delete tour?')
        if(c){
            axios.delete(`${path}/${id}`)
                .then(res=>{
                    setLoading(false)
                    if(res.data.message === 'deleted'){
                        alert('The tour deleted!')
                        setPost(post.filter(e=>e.id !== id))
                    }
                })
        }else{
            setLoading(false)
        }

    }
    return (
        <div  className='post-card'>
            <p className='time'>Created at | {moment(created_at).format('DD-MMM-YYYY')} {data.type}</p>
            <img src={handleImageUrl(thumbnail)} alt="thumbnail"/>
            <h3 className='title'>{displayTitle}</h3>
            <div className="controllers">
                <Link to={`/edit-${path}/${id}`} className='icon-item'>
                    <FontAwesomeIcon icon={faEdit}/>
                </Link>
                <div className='icon-item' onClick={deletePost}>
                    <FontAwesomeIcon icon={faTrash}/>
                </div>
            </div>
        </div>
    );
};

export default Card;